import { render, staticRenderFns } from "./inserirPautaEnfSaudeColectiva.vue?vue&type=template&id=a8cd3266&"
import script from "./inserirPautaEnfSaudeColectiva.vue?vue&type=script&lang=js&"
export * from "./inserirPautaEnfSaudeColectiva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports